import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {JobPosting} from '../types/JobPostingsTypes';

import JobPostingsCounter from './JobPostingsCounter';

type JobPostingsHeaderProps = {
  active: JobPosting[] | undefined;
  archived: JobPosting[] | undefined;
  selected: string | null;
  handleToggle: (value: string) => void;
};

export default function JobPostingsHeader({active, archived, selected, handleToggle}: JobPostingsHeaderProps) {
  const {t} = useTranslation();

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '36px',
        width: {
          xs: '100%',
          md: '800px',
        },
      }}
    >
      <Grid item>
        <Typography variant='h1' display={'flex'} gap={1}>
          {t('companyJobPostings.jobHeader.title')}
        </Typography>
      </Grid>

      <Grid item>
        <JobPostingsCounter
          archived={archived?.length || 0}
          active={active?.length || 0}
          handleSelected={handleToggle}
          selected={selected}
        />
      </Grid>
    </Grid>
  );
}
